import { createReducer, on } from "@ngrx/store";
import {
    fetchPaymentMethod,
    fetchPaymentMethodSuccess,
    fetchPaymentMethodFailure,
    getPaymentMethod,
    getPaymentMethodSuccess,
    getPaymentMethodFailure,
    updateUserPayout,
    updateUserPayoutSuccess,
    updateUserPayoutFailure
} from "./payment-method.action";

import { IState } from "@models/index";

const initialState: IState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  error: null,
  total: 0,
  maxPages: 0,
  perPage: 0,
  currentPage: 0
};

const _paymentMethodReducer = createReducer(
  initialState,
  on(fetchPaymentMethod, (state) => {
        return state;
  }),
  on(fetchPaymentMethodSuccess, (state, { payment }) => {
    const payload = {
      isLoaded: true,
      data: payment.data,
      total: payment.total,
      maxPages: payment.maxPages,
      perPage: payment.length,
      currentPage: payment.currentPage,
      selectedItem: {}
    };

    return { ...state, ...payload };
  }),
  on(fetchPaymentMethodFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(getPaymentMethod, (state, { id }) => {
    const payload = {
      isLoaded: false
    };
    return { ...state, ...payload };
  }),
  on(getPaymentMethodSuccess, (state, { payment }) => {
    const payload = {
      isLoaded: true,
      selectedItem: payment
    };
    return { ...state, ...payload };
  }),
  on(getPaymentMethodFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
  on(updateUserPayout, (state, { payMethod }) => {
    const payload = {
      isLoaded: false,
    }
    return { ...state, ...payload };
  }),
  on(updateUserPayoutSuccess, (state, { payMethod }) => { 
    const index = state.data.findIndex(method => method.id === payMethod.id);
    state.data[index] = payMethod;

    const payload = {
      isLoaded: true,
    }
    return { ...state, ...payload };
  }),
  on(updateUserPayoutFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
);

export function paymentMethodReducer(state, action) {
  return _paymentMethodReducer(state, action);
}
